import { Divider } from 'antd';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const TopCardButtonWrapper = styled.div`
  // correggiamo padding se l'elemento in una StyledResponsiveCard :not(.no-padding)
  .responsive-card.has-padding & {
    margin: -24px;
    margin-top: -24px;
    margin-bottom: 0;
    ${down('sm')} {
      margin: -12px;
      margin-top: -12px;
    }
  }
`;

const DividerStyled = styled(Divider)`
  margin: 0;
`;

export interface TopCardButtonContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Container per il posizionamento del bottone superiore integrato alla card
 */
export function TopCardButtonContainer(props: TopCardButtonContainerProps) {
  return (
    <TopCardButtonWrapper>
      {props.children}
      <DividerStyled />
    </TopCardButtonWrapper>
  );
}
